import makeMap from "@qdabra/forms-shared/makeMap";
import { nth } from "ramda";

export const SCOPE_LOCATION = 'location';
export const SCOPE_TENANT = 'tenant';

export const ENVIRONMENT_VARIABLE_MAXLENGTH_KEY = 255;
export const ENVIRONMENT_VARIABLE_MAXLENGTH_VALUE = 2047;

// This array should be in order of precedence, 
// with highest precedence at the beginning of the array
export const VALID_SCOPES = [
    SCOPE_LOCATION,
    SCOPE_TENANT,
];

export const PRECEDENCE_LOOKUP = makeMap(
    nth(0),
    nth(1),
    VALID_SCOPES.map((x, i) => [x, i]),
);


export const ENVIRONMENT_VARIABLE_KEY_DBXLURL = 'DbxlUrl';
export const ENVIRONMENT_VARIABLE_KEY_DBXLUSERKEY = 'DbxlUserKey';